export default __webpack_public_path__ + "static/media/Children.89f3e7f0.jpg";